import SchedulingFormModule from './containers/schedulingFormModule'

export {default as SchedulingFormModuleLayout} from './components/schedulingFormModuleLayout'

export default SchedulingFormModule
